module.exports = __webpack_public_path__ + "static/media/grammar-1.fbd99f32.svg";